import api from './api';

const proformaInvoiceService = {
  // Get all proforma invoices with pagination and filters
  getAllProformaInvoices: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination parameters
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add filter parameters
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.paymentStatus) queryParams.append('paymentStatus', params.paymentStatus);
      if (params.customer) queryParams.append('customer', params.customer);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.excludeStatus) queryParams.append('excludeStatus', params.excludeStatus);
      
      const response = await api.get(`/proforma-invoices?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching proforma invoices:', error);
      throw error;
    }
  },

  // Get proforma invoice by ID
  getProformaInvoiceById: async (id) => {
    try {
      const response = await api.get(`/proforma-invoices/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching proforma invoice:', error);
      throw error;
    }
  },

  // Create new proforma invoice
  createProformaInvoice: async (proformaInvoiceData) => {
    try {
      const response = await api.post('/proforma-invoices', proformaInvoiceData);
      return response.data;
    } catch (error) {
      console.error('Error creating proforma invoice:', error);
      throw error;
    }
  },

  // Update proforma invoice
  updateProformaInvoice: async (id, proformaInvoiceData) => {
    try {
      const response = await api.put(`/proforma-invoices/${id}`, proformaInvoiceData);
      return response.data;
    } catch (error) {
      console.error('Error updating proforma invoice:', error);
      throw error;
    }
  },

  // Delete proforma invoice (soft delete)
  deleteProformaInvoice: async (id) => {
    try {
      const response = await api.delete(`/proforma-invoices/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting proforma invoice:', error);
      throw error;
    }
  },

  // Convert proforma invoice to tax invoice
  convertToTaxInvoice: async (id) => {
    try {
      const response = await api.post(`/proforma-invoices/${id}/convert-to-tax-invoice`);
      return response.data;
    } catch (error) {
      console.error('Error converting proforma invoice to tax invoice:', error);
      throw error;
    }
  },

  // Get proforma invoice statistics
  getProformaInvoiceStats: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      
      const response = await api.get(`/proforma-invoices/stats?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching proforma invoice stats:', error);
      throw error;
    }
  }
};

export default proformaInvoiceService;

